<template>
  <div id="combo-detail">
    <h1 id="h1ComboDetail" class="invisible p-absolute"></h1>
    <div class="header xs-relative xs-fill-white shadow-down-1 xs-z-100 xs-h-40 md-h-60 lg-static lg-width-auto"
         style="display: none">
      <div class="lg-container xs-flex-center md-justify-start md-items-start xs-relative xs-full-height ">
        <a
          class="xs-flex xs-items-center xs-text-gray-medium xs-absolute xs-l-15 xs-t-0 xs-b-0 xs-opacity-50 close-combo-popup-items"
          href="javascript: void(0);" @click="closeGroup">
          <i class="xs-ml-5 icon-caret-left"></i>
        </a>
        <div class="xs-relative xs-z-500 xs-mx-auto">
          <a class="header-logo xs-block md-pl-30 xs-fill-white lg-fill-none circle" style="padding: 2px;"
             href="javascript: void(0)" @click="$router.push({'name': 'home'})">
            <span class="logo"></span>
          </a>
        </div>
      </div>
    </div>
    <div class="combo-details-breadcrumb hidden-xs hidden-sm">
      <div class="mycontainer">
        <div class="combo-infos">
          <a href="javascript: void(0);"
             @click="back()" style="padding-left: 15px;">
            <i class="glyphicon glyphicon-chevron-left"></i> {{$t('cart.back_to_promo')}}
          </a>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
    <div>
      <div class="combo-details combo-details-header ">
        <div class="mycontainer">
          <div class="combo-image">
            <a href="javascript: void(0);" @click="$root.$emit('onProcessChangeCategory')" type="button"
               class="close close-left pull-left  hidden-lg" data-dismiss="modal" aria-label="Close" style="z-index: 101;">
               <span aria-hidden="true">×</span>
            </a>
            <div class="app-only-deals" v-if="isAppOnly">
              <div class="container-blur"></div>
              <div class="ribbona ribbona-app-only">
                <span>{{ $t('app_only')}} </span>
              </div>
              <img v-bind:src="(comboDetails.image.desktop_thumbnail) ? comboDetails.image.desktop_thumbnail : $const.IMG_PIZZA_DEFAULT" v-if="!empty(comboDetails) && !empty(comboDetails.image) && comboDetails.image.desktop_thumbnail">
            </div>
            <img v-bind:src="(comboDetails.image.desktop_thumbnail) ? comboDetails.image.desktop_thumbnail : $const.IMG_PIZZA_DEFAULT" v-else-if="!empty(comboDetails) && !empty(comboDetails.image) && comboDetails.image.desktop_thumbnail">
            <div class="clearfix"></div>
          </div>
          <div class="combo-infos">
            <div class="combo-name heading-hr lg:remove--hr lg:text-left lg:justify-start">
              {{comboDetails.name}}
            </div>
<!--            <div class="combo-description">-->
<!--              <nl2br v-if="comboDetails.marketing_description" tag="div" :text="comboDetails.marketing_description"/>-->
<!--            </div>-->
            <div class="combo-description">
              <nl2br v-if="comboDetails.main_description" tag="div" :text="comboDetails.main_description"/>
            </div>
            <div class="" role="button" @click="showAccordionTC = !showAccordionTC" v-if="comboDetails.t_and_c">
              <h6 class="panel-title t14 fw600">
                <i class="fa fa-caret-down" v-if="showAccordionTC"></i>
                <i class="fa fa-caret-up" v-if="!showAccordionTC"></i>
                <span class="pl-5">{{$t('t_and_c')}}</span>
              </h6>
            </div>
            <collapse class="" v-model="showAccordionTC" v-if="comboDetails.t_and_c">
              <div class="menu-description t14" style="color:#d9b084">
                <nl2br tag="div" :text="comboDetails.t_and_c"/>
              </div>
            </collapse>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
    <div class="mycontainer-main">
      <div class="main-content list-item-menu">
        <div class="combo-content">
          <div v-for="(cbgroup,index) in comboDetails.groups" :key="index"
               class="combo-group cursor-pointer deal-option--incomplete group-1686 group-index-0"
               v-bind:data-index="index"
               v-bind:class="{open: cbgroup.isOpen, 'current': activeGroup == index, 'done' : cbgroup.done }"
               @click.stop="chooseDetails(cbgroup,index)">
            <div class="combo-group-name t13">{{cbgroup.name}}</div>
            <!-- ############# -->
            <!--begin group combo choosed-->
            <div class="combo-group-description t15  text-grey" data-content="Choose your pizza"
                 v-for="(item,idc) in combogroup" :key="idc" v-if="item.GroupId == cbgroup.id">
              <span class="fw600 hide" v-if="!item.item.id">Choose your pizza</span>
              <div v-if="item.GroupId == cbgroup.id && (item.item.id || item.item.isHalf)">
                <strong class="text-black text-capitalize fw600">{{convertString(item.item.name)}}</strong>
                <span class="pull-right text-black fw600 t13" @click.stop="removeGroup(cbgroup.id)">
                    <i class="pull-right fa fa-times-circle text-ccc icon-remove"></i>
                  </span>
                <span class="pull-right text-black fw600 t13" v-if="item.GroupId == cbgroup.id">+{{$const.CURRENCY}} {{formatNumDisplay(item.item.totalPrice)}}</span>
              </div>
              <!--START: H&H choosed left-right name-->
              <div v-if="item.GroupId == cbgroup.id && (item.item.id || item.item.isHalf)"
                :key="genUniqueKey(product)"
                v-for="(product) in item.item.products"
              >
                <span class="text-black text-capitalize">{{convertString(product.name)}}</span>
                <div v-if="product.toppings.extra.length > 0 || product.toppings.remove.length > 0">
                  <div class="cl-78838c text-black text-capitalize ml-10"
                    v-if="product.toppings.extra.length > 0"
                    v-for="(extraToppingId, index) in product.toppings.extra"
                    :key="genUniqueKey(extraToppingId) + index"
                  >{{$t('cart.add')}}: {{getHaftHaftToppingNameById(extraToppingId, cbgroup)}}</div>
                  <div class="cl-78838c text-black text-capitalize ml-10"
                    v-if="product.toppings.remove.length > 0"
                    v-for="(removeToppingId, index) in product.toppings.remove"
                    :key="genUniqueKey(removeToppingId) + index"
                  >{{$t('cart.remove')}}: {{getHaftHaftToppingNameById(removeToppingId, cbgroup)}}</div>
                </div>
              </div>
              <!--END: H&H choosed left-right name-->
              <div v-for="addItem in item.item.Add" :key="genUniqueKey(addItem)"
                   v-if="item.GroupId == cbgroup.id && item.item.Add.length > 0 && addItem.special == '1'">
                <span class="cl-78838c text-capitalize t13">{{convertString(addItem.name)}}</span>
                <span class="pull-right text-black fw600 t13 pr20" v-if="addItem.prices">+{{$const.CURRENCY}} {{formatNumDisplay(getPriceTopping(addItem))}}</span>
              </div>
              <div v-for="addItem in item.item.Add" :key="genUniqueKey(addItem)"
                   v-if="item.GroupId == cbgroup.id && item.item.Add.length > 0 && addItem.special != '1'">
                <span class="cl-78838c text-capitalize t13">{{$t('cart.add')}}: {{convertString(addItem.name)}}</span>
                <span class="pull-right text-black fw600 t13 pr20" v-if="addItem.prices">+{{$const.CURRENCY}} {{formatNumDisplay(getPriceTopping(addItem))}}</span>
              </div>
              <div v-for="noItem in item.item.Remove" :key="genUniqueKey(noItem)"
                   v-if="item.GroupId == cbgroup.id && item.item.Remove.length > 0">
                <span class="cl-78838c text-capitalize t13">{{$t('cart.remove')}}: {{convertString(noItem.name)}}</span>
              </div>
            </div>
            <!-- endgroup combo choosed -->

            <!-- ############# -->
            <div class="combo-group-show">
             <span class="add-icon mr-0 ml-5 fa-plus-icon" v-if="!cbgroup.done">
               <i class="add-icon__v"></i>
               <i class="add-icon__h"></i>
             </span>
            </div>
            <div class="combo-group-details"
                 :show="cbgroup.isShow" :class="">
              <div class="combo-group-variants list-item-menu">
                <div v-for="(menuItems,indexItem) in cbgroup.items"
                     :key="indexItem"
                     class="item-menu cols-4 show-detail-modal while-tooltip"
                     data-toggle="tooltip"
                     v-bind:title="menuItems.main_description"
                     style="padding-bottom: 0px;"
                     @click.stop="choosePizza(menuItems,cbgroup.id)">
                  <div class="display-flex flex-column">
                    <div class="menu-image">
                      <img v-if="menuItems.image && menuItems.image.desktop_thumbnail"
                           v-bind:src="menuItems.image.desktop_thumbnail" style="">
                      <img v-else v-bind:src="$const.IMG_PIZZA_DEFAULT" style="">
                    </div>
                    <div class="flag flag--">
                      <span class="flag__inner"></span>
                    </div>
                    <div class="menu-name text-left" style="z-index: 1">{{menuItems.name}}
                      <img alt="" v-bind:src="(img.image && img.image.icon) ? img.image.icon : ''" v-for="(img, indexI) in menuItems.menu_attributes" :key="indexI" width="25" class="pl-5" />
                      <span class="t10 bold label tag tag-"></span>
                    </div>
                    <div class="menu-description hidden-xs " style="z-index: 1; word-break: break-word;">
                      <nl2br v-if="menuItems.marketing_description" tag="div" :text="menuItems.marketing_description"/>
                    </div>
                  </div>
                  <div v-if="!hasSelection(menuItems)"
                       class="btn btn-success btn-add-single-item text-left" style="width: 100%;"
                       v-on:click.stop="addToBasket(menuItems, cbgroup.id, index)">
                    {{$t('button_add')}} <span class="pull-right">{{ $const.CURRENCY }} {{ formatNumDisplay(menuItems.min_price)}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div class="bg-white modal__actions-fixed" v-if="missingGroup || isAppOnly">
        <div class="mycontainer">
          <div class="text-center modal-action-btn">
            <a v-if="isAppOnly" target="_blank" :href="linkAppOnly" type="button" class="btn btn-danger btn-add-to-cart btn-get-app-only">
              <span>{{$t('get_the_app_now')}}</span>
            </a>
            <div v-else type="button" class="btn btn-success btn-add-to-cart" @click="addTocart()" style=""><span
              class="pull-left">{{$t('cart.add_deal_to_my_basket')}}</span> <span class="pull-right combo-price">+{{$const.CURRENCY}} {{formatNumDisplay(totalPrice)}}</span>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<style lang='scss' scoped>
  @import '../../assets/css/combo_details.css';
</style>
<script type="text/javascript">
import {mapGetters} from 'vuex'
import { getExperiment } from '@pizza-hut/lib-experiments/lib'
import ModalCombo from '../popup/ModalCombo.vue'
import ModalPopupHalf  from '../popup/ModalPizzaHalf.vue'
import DispositionPopup from '@/components/home/HomeLocalizationKwNewDesign'
import DispositionPopupOld from '@/components/home/HomeLocalizationKwNewDesignBackup'
import {mapActions} from 'vuex'
import * as action from '@/store/actions'

export default {
  components: {
    DispositionPopup,
    DispositionPopupOld
  },
  mounted() {
    let vm = this
    this.$cart.init(this)

    if(document.documentElement.clientWidth < 768){
      document.body.classList.add('mobile')
    }
    if (this.$route.params.coupon) {
      this.coupon = this.$route.params.coupon
      let item = this.$cart.get(this)
      // because vm.$router.push({name: 'combo-detail', params: {nameseo: data.menu[0].friendly_seo_name || data.menu[0].uuid, ssid: 'coupon', coupon: data.coupon}})
      // so if not have name seo we will use uuid of free item
      let nameseo = item.current_coupon_item.name_seo || item.current_coupon_item.uuid
      if (!item.current_coupon_item || item.current_coupon_item.coupon !== this.$route.params.coupon || nameseo !== this.$route.params.nameseo) {
        this.$root.$emit('onProcessChangeCategory')
      }
      this.getComboDetailsFreeItem(item.current_coupon_item.menu[0])
    } else {
      // to wait tenant call to get LocalizeByLatlongConfig, if remove AB testing please remove set timeout
      setTimeout(() => {
        this.getComboDetails()
      }, 500)
    }
    this.$root.$on('triggerLoadDealDetail', (id) => {
      let _menu = this.lodash.cloneDeep(this.comboDetails)
      _menu.isMultiple = this.isMultiple
      this.eventTrackingProductDetail(this, _menu, this.$const.CARD_ITEM_TYPE.COMBO, 'product-details')
      for (let j in this.comboDetails.groups) {
        if (this.comboDetails.groups[j].id == id) {
          this.eventTrackingModuleLoadDeal(this, this.comboDetails, this.comboDetails.groups[j]);
          break
        }
      }
    })
    this.$root.$on('responseComboGroup', (obj, id) => {
      vm.changeCombo(obj, id)
      vm.checkMissingGroup()
      vm.calTotalPrice()
      vm.closeGroup()
    })
  },
  computed: {
    ...mapGetters({
      uuidForNameseoDuplicate: 'uuidForNameSeoDuplicate',
      isLocalizeByLatlongConfig: 'isLocalizeByLatlongConfig'
    })
  },
  destroyed() {
    this.setUuidForNameseoDuplicate('')
    this.$root.$off('triggerLoadDealDetail')
  },
  methods: {
    ...mapActions({
      setUuidForNameseoDuplicate: action.SET_UUID_FOR_NAMESEO_DUPLICATE
    }),
    hasSelection(item) {
      if(item.isHalf) {
        return true
      }
      if (item && item.first_layers && item.first_layers !== undefined) {
        return item.first_layers.length > 1 || (item.first_layers.length == 1 &&  item.first_layers[0].second_layers.length > 1)
      }
      return false
    },
    /**
     * Get topping price
     * */
    getPriceTopping(add) {
      for (let i in this.combogroup) {
        let obj = this.combogroup[i].item
        for (let o in obj.Add) {
          if (obj.Add[0].uuid == add.uuid) {
            return add.prices[obj.choosedFirst.sku] ? add.prices[obj.choosedFirst.sku] : 0
          }
        }
      }

      return 0
    },
    changeCombo(obj, id) {
      for (let i in this.combogroup) {
        for (let o in obj) {
          if (this.combogroup[i].GroupId == obj[o].GroupId) {
            this.combogroup[i]['item'] = obj[o].item
            //this.$forceUpdate(this.combogroup[i], 'item', obj[o].item)
          }
        }
      }
      for (let j in this.comboDetails.groups) {
        if (this.comboDetails.groups[j].id == id) {
          this.comboDetails.groups[j].done = true
        }
      }
    },
    getComboDetails() {
      let nameSeo = this.$route.params.nameseo
      if (!this.checkPosition(this)) {
        if (this.isLocalizeByLatlongConfig) {
          this.$modal.show(DispositionPopup, {isPopup: true, comboNameseo: nameSeo}, {class: 'disposition-popup'})
        } else {
          this.$modal.show(DispositionPopupOld, {isPopup: true, comboNameseo: nameSeo}, {class: 'disposition-popup'})
        }
      } else {
        let vm = this
        let data = {
          'friendly_seo_name': nameSeo,
          'tier': this.$disposition.getByKey(this, 'tier', '1'),
          'order_type': this.$disposition.getByKey(this, 'orderType', 'D').charAt(0),
          'outlet_code': this.$disposition.getByKey(this, 'outletCode', null),
          'order_time': this.convertSecond(this.convertDateTimeToUTC(this.$disposition.getByKey(this, 'collectionTimeText', '')))
        }
        // let data = {'categoryID': categoryId, 'tier': this.$disposition.getByKey(this, 'tier', '0'), 'orderType': this.$disposition.getByKey(this, 'orderType', 'N').charAt(0)}
        this.axios.getComboDetailsFriendlyNameSeo(data, function (response) {
          // in case api have not name seo from edit cart or free item, that will call old api with uuid then handle same response
          if (response.data.error) {
            let uuid = vm.uuidForNameseoDuplicate || nameSeo
            // duplicate friendly name seo
            if (response.data.error.code === vm.$const.DUPLICATE_FRIENDLY_NAME_SEO && !vm.uuidForNameseoDuplicate) {
              vm.$notify({
                type: 'error',
                title: vm.$t('invalid_item')
              })
              let slug = vm.$route.params.slug
              vm.redirectToMenuPage(slug)
            } else {
              vm.getComboDetailsWithUuid(uuid)
            }
          } else {
            vm.handleResponseData(response, data)
          }
        })
      }
    },
    getComboDetailsWithUuid (uuid) {
      let vm = this
      let dataWithUUid = {
        'tier': this.$disposition.getByKey(this, 'tier', '1'),
        'order_type': this.$disposition.getByKey(this, 'orderType', 'D').charAt(0),
        'outlet_code': this.$disposition.getByKey(this, 'outletCode', null),
        'order_time': this.convertSecond(this.convertDateTimeToUTC(this.$disposition.getByKey(this, 'collectionTimeText', '')))
      }
      this.axios.getComboDetails(uuid, dataWithUUid, function (response) {
        let ssid = vm.$route.params.ssid || ''
        let coupon = vm.$route.params.coupon || ''
        history.replaceState({}, '', `/combo-detail${'/' + uuid}${ssid ? '/' + ssid : ''}${coupon ? '/' + coupon : ''}`)
        vm.handleResponseData(response, dataWithUUid)
      })
    },
    handleResponseData (response, data) {
      let vm = this
      vm.comboDetails = response.data.data.item
      vm.isAppOnly = vm.getValueFromAttr(vm.comboDetails, 'customize.promote_for_download_app', false)
      vm.linkAppOnly = vm.getValueFromAttr(vm.comboDetails, 'customize.deep_link_download_app', '')
      // SEO index comboDetails
      if (vm.comboDetails.customize && vm.comboDetails.customize.seo_configuration) {
        let seoConfig = vm.comboDetails.customize.seo_configuration
        let h1 = document.getElementById('h1ComboDetail')
        let SEOH1Category = seoConfig.h1_headings || ''
        h1.innerHTML = SEOH1Category
        vm.setConfigSEOTitleDesKeywords(seoConfig)
      } else {
        document.title = vm.$t('title_detail_menu', {title: vm.comboDetails.name || ''})
      }
      vm.comboDetails.groups.map((combo) => {
        if (combo.min === 0) {
          vm.min++
        }
      })
      if (vm.empty(vm.comboDetails)) {
        vm.$notify({
          type: 'error',
          title: vm.$t('combo_detail_notfound')
        })
        vm.$root.$emit('onProcessChangeCategory')
        return false
      }
      if (vm.comboDetails.groups.length > 1) {
        vm.isMultiple = true
      }
      let _menu = vm.lodash.cloneDeep(vm.comboDetails)
      _menu.isMultiple = vm.isMultiple
      vm.eventTrackingProductDetail(vm, _menu, vm.$const.CARD_ITEM_TYPE.COMBO, 'product-details')
      // Add data for cart item
      vm.$cart.tier = data.tier
      vm.$cart.order_type = data.order_type
      // Add data for cart item
      vm.getComboDetailHalfHalf()
      vm.getComboGroup()
      vm.checkMissingGroup()
      vm.autoAddItemGroup()
      vm.comboDetails.groups.map(combo => {
        vm.autoAddItemDefault(combo)
      })
      // vm.comboDetails.groups[0].isOpen = true
      vm.autoOpenGroup()
    },
    /*
      Set the default item in the combo BA20-893
      * input: combo group
      * output: single have defaut = 1
     */
    autoAddItemDefault (comboGroup) {
      for (let itemIndex = 0; itemIndex < comboGroup.items.length; itemIndex++) {
        if (!comboGroup.items[itemIndex].default) continue
        let menu = this._.cloneDeep(comboGroup.items[itemIndex])
        menu.first_layers = []
        for (let firstIndex = 0; firstIndex < comboGroup.items[itemIndex].first_layers.length; firstIndex++) {
          if (!comboGroup.items[itemIndex].first_layers[firstIndex].default) continue
          menu.first_layers.push(this._.cloneDeep(comboGroup.items[itemIndex].first_layers[firstIndex]))
          menu.first_layers[0].second_layers = []
          for (let secondIndex = 0; secondIndex < comboGroup.items[itemIndex].first_layers[firstIndex].second_layers.length; secondIndex++) {
            if (!comboGroup.items[itemIndex].first_layers[firstIndex].second_layers[secondIndex].default) continue
            menu.first_layers[0].second_layers.push(comboGroup.items[itemIndex].first_layers[firstIndex].second_layers[secondIndex])
          }
        }
        this.addToBasket(menu, comboGroup.id)
      }
    },
    getComboDetailsFreeItem(item) {
      this.comboDetails = item
      this.getComboDetailHalfHalf()
      this.getComboGroup()
      this.checkMissingGroup()
    },
    closeGroup() {
      for (let i in this.comboDetails.groups) {
        this.comboDetails.groups[i]['isShow'] = false
        this.comboDetails.groups[i]['isOpen'] = false
      }
      this.activeGroup = null
      document.body.classList.remove('combo-popup-items')
    },
    chooseDetails(obj, index, autoSelect = false) {
      let isMobile = false
      if(document.documentElement.clientWidth < 768){
        isMobile = true
      }
      /*if (this.activeGroup == index && document.body.classList.contains('combo-popup-items') && document.documentElement.clientWidth < 768) {
        return false
      }*/

      obj.isOpen = !obj.isOpen

      //this.$set(obj, 'isShow', !obj.isShow)
      this.activeGroup = index
      if(isMobile){
        obj.isOpen = true
        this.eventTrackingModuleLoadDeal(this, this.comboDetails, this.comboDetails.groups[index])

        if(!autoSelect){
          document.body.classList.add('combo-popup-items')
        }
      }else{
        if (!obj.isOpen) {
          document.body.classList.remove('combo-popup-items')
          this.activeGroup = null
        } else {
          this.eventTrackingModuleLoadDeal(this, this.comboDetails, this.comboDetails.groups[index])
          if(!autoSelect){
            document.body.classList.add('combo-popup-items')
          }
        }
      }
    },
    /**
     * Trigger before open modal popup
     * */
    beforeOpen(event) {
      document.body.classList.add('modal-open')
    },
    /**
     * Trigger before close modal popup
     * */
    beforeClose(event) {
      document.body.classList.remove('modal-open')
    },
    choosePizza(obj, id) {
      if (obj.half_half_first_layers ||
        (obj.first_layers &&
        (obj.first_layers.length > 1 ||
        (obj.first_layers.length === 1 && obj.first_layers[0].second_layers && obj.first_layers[0].second_layers.length > 0)))) {
        let popup = ModalCombo
        let param = {
          menu: obj,
          sizecrust: this.comboDetails.sizecrustimages,
          extracheese: this.comboDetails.extracheese,
          cGroup: JSON.parse(JSON.stringify(this.combogroup)),
          id: id,
          comboUUID: this.$route.params.id,
          comboName: this.comboDetails.name,
          isMultiple: this.isMultiple
        }
        if(obj.isHalf) {
          popup = ModalPopupHalf
          param = {
            menu: obj,
            scrollable: false,
            mfirst: {},
            msecond: {},
            extraCheese: [],
            onlyLunch: obj.onlyLunch,
            comboGroupId : id,
            cGroup: JSON.parse(JSON.stringify(this.combogroup)),
          }
        }
        this.$modal.show(popup, param, {class: 'modal-menu', transition: 'nice-modal-fade', overlayTransition: 'overlay-fade'}, {
          'before-open': this.beforeOpen,
          'before-close': this.beforeClose
        })
      }
    },
    getComboGroup() {
      for (let gr in this.comboDetails.groups) {
        // if (this.comboDetails.groups[gr].items.length > 1) {
        this.combogroup.push({
          'GroupUUID': this.comboDetails.groups[gr].uuid,
          'GroupId': this.comboDetails.groups[gr].id,
          'item': {}
        })
        // }
      }
    },
    checkMissingGroup() {
      let groupItem = this.combogroup.length
      let addItem = 0
      for (let k in this.combogroup) {
        if (this.combogroup[k].item.name !== undefined && this.combogroup[k].item.name.length > 0) {
          addItem++
        }
      }
      this.missingGroup = (addItem >= groupItem - this.min)
    },
    calTotalPrice() {
      let total = 0
      this.totalPrice = 0
      total += parseFloat(this.comboDetails.price)
      for (let k in this.combogroup) {
        if (this.combogroup[k].item.hasOwnProperty('totalPrice')) {
          total += parseFloat(this.combogroup[k].item.totalPrice)
        }
      }
      this.totalPrice = total
    },
    removeGroup(id) {
      for (let k in this.combogroup) {
        if (this.combogroup[k].GroupId == id) {
          this.combogroup[k]['item'] = {}
        }
      }
      for (let j in this.comboDetails.groups) {
        if (this.comboDetails.groups[j].id == id) {
          this.comboDetails.groups[j].done = false
        }
      }
      this.checkMissingGroup()
    },
    getHaftHaftToppingNameById (id, cbgroup) {
      let toppingName = ''

      if (cbgroup.half_half_list_item && cbgroup.half_half_list_item.length > 0) {
        for (let i = 0; i < cbgroup.half_half_list_item.length; i++) {
          // Extra toppings
          if (cbgroup.half_half_list_item[i].toppings &&
            cbgroup.half_half_list_item[i].toppings.extra
          ) {
            for (let j = 0; j < cbgroup.half_half_list_item[i].toppings.extra.length; j++) {
              let extraList = cbgroup.half_half_list_item[i].toppings.extra
              if (extraList[j].id === id) {
                toppingName = extraList[j].name
                break
              }
            }
          }

          // Default toppings
          if (cbgroup.half_half_list_item[i].toppings &&
            cbgroup.half_half_list_item[i].toppings.default
          ) {
            for (let j = 0; j < cbgroup.half_half_list_item[i].toppings.default.length; j++) {
              let defaultList = cbgroup.half_half_list_item[i].toppings.default
              if (defaultList[j].id === id) {
                toppingName = defaultList[j].name
                break
              }
            }
          }
        }
      }

      return toppingName
    },
    addToBasket(menu, groupID, idx) {
      if (!menu) {
        return false
      }
      let firstSelected = {}
      let secondSelected = {}
      let price = 0
      price += parseFloat(menu.price > 0 ? menu.price : 0)
      if (menu.first_layers && menu.first_layers.length > 0) {
        firstSelected = menu.first_layers[0]
        price += parseFloat(firstSelected.price > 0 ? firstSelected.price : 0)
        if (firstSelected.second_layers && firstSelected.second_layers.length > 0) {
          secondSelected = firstSelected.second_layers[0]
          price += parseFloat(secondSelected.price > 0 ? secondSelected.price : 0)
        }
      }

      let cGroup = JSON.parse(JSON.stringify(this.combogroup))
      for (let cb in cGroup) {
        if (cGroup[cb].GroupId == groupID) {
          cGroup[cb].item.name = menu.name + ' ' + (firstSelected.name != undefined ? firstSelected.name : '')
          cGroup[cb].item.id = menu.id
          cGroup[cb].item.choosedSecond = secondSelected
          cGroup[cb].item.choosedFirst = firstSelected
          cGroup[cb].item.price = price
          cGroup[cb].item.totalPrice = price
          cGroup[cb].item.Default = []
          cGroup[cb].item.Remove = []
          cGroup[cb].item.Add = []
          cGroup[cb].item.uuid = menu.uuid
          cGroup[cb].item.CheesePrice = 0
          cGroup[cb].item.image = (menu.image && menu.image.desktop_thumbnail) ? menu.image.desktop_thumbnail : ''
        }
      }
      this.closeGroup()
      let pro = {
        item: menu,
        id: menu.uuid,
        uuid: menu.uuid,
        combo_uuid: this.$route.params.id,
        name: menu.name,
        price: price,
        first: firstSelected || {},
        second: secondSelected || {},
        sku: this.comboDetails.sku || ''
      }
      let variantUUid = ''
      if (!this.empty(firstSelected) && firstSelected.uuid != '') {
        variantUUid = firstSelected.uuid
      }
      if (!this.empty(secondSelected) && secondSelected.uuid != '') {
        variantUUid += '-' + secondSelected.uuid
      }
      pro.variant_uuid = variantUUid
      this.evenTrackingProductClick(this, pro, 'add-to-deal')
      this.$root.$emit('responseComboGroup', cGroup, groupID)
    },
    addTocart() {
      let item = {
        'group': {},
        'selling_start': this.comboDetails.selling_start,
      }
      const products = [];
      if (this.coupon) {
        item.group.coupon_code = this.coupon
      }
      item.group['outlet_code'] = this.getOutletCode(this)
      item.group['tier'] = this.$cart.tier
      item.group['order_type'] = this.$cart.order_type
      item.group['order_time'] = this.getTimePickerDate(this)
      item.group['product_type'] = this.$const.CARD_ITEM_TYPE.COMBO
      item.group['combo_id'] = this.comboDetails.uuid
      item.group['quantity'] = 1
      item.group['category_uuid'] = this.$store.getters.category_uuid || this.getValueFromAttr(this.comboDetails, 'display_categories.0.uuid')

      let pro = {
        items: [],
        item: this.comboDetails,
        id: this.comboDetails.uuid,
        name: this.comboDetails.name,
        price: this.totalPrice
      }
      for (let i in this.combogroup) {
        let obj = this.combogroup[i].item
        let product = {}
        if(Object.values(obj).length <= 0) { continue }
        product.category_id = null
        product.combo_group_id = this.combogroup[i].GroupUUID
        if(obj.isHalf) {
          product.product_id = "half-half"
          product.products = obj.products
          product.toppings = {}
          product.toppings.remove = []
          product.toppings.extra = []
        } else {
          product.product_id = obj.uuid
          product.first_id = obj.choosedFirst.uuid
          product.second_id = obj.choosedSecond.uuid
          product.toppings = {}
          product.toppings.remove = this.$cart.getToppingById(obj.Remove)
          product.toppings.extra = this.$cart.getToppingById(obj.Add)
        }
        products.push(product)
        pro.items.push({
          item: obj,
          first: obj.hasOwnProperty('isHalf') && obj.isHalf ? {} : obj.choosedFirst,
          second: obj.hasOwnProperty('isHalf') && obj.isHalf ? {} : obj.choosedSecond
        })
      }

      // Process to make sure that combo_group_id of product is unique
      item.products = this.lodash.uniqBy(products, 'combo_group_id');
      if (!this.$route.params.ssid || this.$route.params.ssid == 'coupon') {
        this.eventTrackingAddToCart(this, pro, 'product', this.$const.CARD_ITEM_TYPE.COMBO)
        this.$cart.insert(this, item)
      } else {
        item.group['item_id'] = this.$route.params.ssid
        this.$cart.updateCart(this, item)
      }
      this.$cart.clearFreeItem(this)
      this.$root.$emit('onProcessChangeCategory')
    },
    getImage(data) {
      if (!this.empty(data) && data.image.length > 0) {
        return data.image[0].icon
      }
      return ''
    },
    /*
      Automatic add item when the group only 1 item
     */
    autoAddItemGroup() {
      for (let group of this.comboDetails.groups) {
        let choose = false
        if (group.items.length == 1){
          if (!group.items[0].first_layers || !group.items[0].first_layers.length) {
            choose = true
          } else if (group.items[0].first_layers.length == 1 &&
            (!group.items[0].first_layers[0].second_layers || group.items[0].first_layers[0].second_layers.length <= 1)) {
            choose = true
          }

          if (choose && group.items[0].default !== 1) {
            this.addToBasket(group.items[0], group.id)
          }
        }
      }
    },
    /**
     * Automatic open group combo
     */
    autoOpenGroup() {
      let flag = false
      for (let i in this.comboDetails.groups) {
        /*let item = this.comboDetails.groups[i].items[0]
        if (item && item.first_layers && item.first_layers.length) {
          return item.first_layers.length >= 1 || item.first_layers.length == 1 && item.first_layers[0].second_layers.length > 1
        }*/

        let group = this.comboDetails.groups[i]
        let first = group.items[0]
        let choose = false

        if (group.items.length > 1) {
          choose = true
        }else{
          if(first && first.first_layers && first.first_layers.length > 1){
            choose = true
          }else if(first && first.first_layers[0].second_layers.length > 1){
            choose = true
          }
        }

        let checkDefault = this.comboDetails.groups[i].items.filter(item => item.default)

        if(choose && checkDefault.length <= 0){
          this.chooseDetails(this.comboDetails.groups[i], i, true)
          break
        }
      }
    },
    getComboDetailHalfHalf() {

      let hasHalfHalf = true
      let currentOutletCode = parseInt(this.getOutletCode(this))

      if (_.includes(this.$const.HALF_HALF_EXCLUDE_STORE, currentOutletCode)) {
        hasHalfHalf = false
      }
      if(hasHalfHalf) {
        for (let i in this.comboDetails.groups) {
            if (this.comboDetails.groups[i].hasOwnProperty('has_half_half') && this.comboDetails.groups[i].has_half_half == 1) {
                let half = this.getHalf(this, this.$const.HALF_HALF_SET.NORMAL)
                half['half_half_list_item'] = this.comboDetails.groups[i].half_half_list_item
                half['half_half_first_layers'] = this.comboDetails.groups[i].half_half_first_layers
                this.comboDetails.groups[i].items.unshift(half);
            }
        }
      }
    },
    getHalf(vm, onlyLunch, type = 0) {
      let image = ''
      let half = {}
      half.main_description = '';
      half.isHalf = true;

      if (onlyLunch == vm.$const.HALF_HALF_SET.LUNCH) {
        half.uuid = vm.$const.HALF_HALF_LUNCH_UUID;
        half.name = vm.$t('half_lunch_name');
        half.marketing_description = vm.$t('half_lunch_description');
        half.price = vm.$const.HALF_HALF_LUNCH_PRICE
        half.display_price = vm.$const.HALF_HALF_LUNCH_PRICE
        half.onlyLunch = vm.$const.HALF_HALF_SET.LUNCH

        image = vm.$const.HALF_HALF_IMAGES.LUNCH_4
      } else if (onlyLunch == vm.$const.HALF_HALF_SET.NORMAL) {
        half.uuid = vm.$const.HALF_HALF_UUID;
        half.name = vm.$t('btn_hatf_halt');
        half.marketing_description = vm.$t('half_description');
        half.price = vm.$const.HALF_HALF_PRICE
        half.display_price = vm.$const.HALF_HALF_PRICE
        half.onlyLunch = vm.$const.HALF_HALF_SET.NORMAL

        image = vm.$const.HALF_HALF_IMAGES.NORMAL_4
      } else if (onlyLunch == vm.$const.HALF_HALF_SET.BOTH) {
        if (type == 0) {
          half.uuid = vm.$const.HALF_HALF_UUID;
          half.name = vm.$t('btn_hatf_halt');
          half.marketing_description = vm.$t('half_description');
          half.price = vm.$const.HALF_HALF_PRICE
          half.display_price = vm.$const.HALF_HALF_PRICE
          half.onlyLunch = vm.$const.HALF_HALF_SET.NORMAL
          half.columnDisplay = 2
          image = vm.$const.HALF_HALF_IMAGES.NORMAL_2
        } else {
          half.uuid = vm.$const.HALF_HALF_LUNCH_UUID;
          half.name = vm.$t('half_lunch_name');
          half.marketing_description = vm.$t('half_lunch_description');
          half.price = vm.$const.HALF_HALF_LUNCH_PRICE
          half.display_price = vm.$const.HALF_HALF_LUNCH_PRICE
          half.onlyLunch = vm.$const.HALF_HALF_SET.LUNCH
          image = vm.$const.HALF_HALF_IMAGES.LUNCH_2
          half.columnDisplay = 2
        }
      }
      let regex = /<br\/>/gi
      half.marketing_description = half.marketing_description.replace(regex, "\n")

      half.image = {
        desktop_thumbnail: image,
        mobile_thumbnail: image
      };

      return half;
    }
  },
  data() {
    return {
      isMultiple: false,
      showAccordionTC: false,
      combogroup: [],
      missingGroup: false,
      activeGroup: false,
      totalPrice: 0,
      coupon: '',
      comboDetails: {},
      min: 0,
      isAppOnly: false,
      linkAppOnly: ''
    }
  },
  watch: {
    missingGroup(newValue, oldValue) {
      if (newValue) {
        let pro = {
          combogroup: this.combogroup,
          item: this.comboDetails,
          price: this.totalPrice
        }
        this.eventTrackingProductViewCombo(this.comboDetails, null, pro, this)
      }
    }
  }
}
</script>
<style>
.combo-name {
    font-family: SharpSansBold, Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif !important;
  }
  .combo-group-name {
    font-family: SharpSansSemiBold, Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif !important;
  }
  .modal__actions-fixed {
    -webkit-box-shadow: 0 0 20px 5px rgba(0, 0, 0, .05);
    -webkit-transform: translateZ(0);
    background: #fff;
    bottom: 0;
    box-shadow: 0 0 20px 5px rgba(0, 0, 0, .05);
    height: auto;
    left: 0;
    padding: 5px;
    position: fixed;
    right: 0;
    z-index: 10;
  }
</style>



// WEBPACK FOOTER //
// src/components/combo/ComboDetail.vue